"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Returns the index of the given item id
 * @param  {Number|String} id
 * @param  {Array} data
 * @param  {Function} getIdProperty
 * @return {Int}
 */
function findItemIndex(_ref) {
  var id = _ref.id,
      data = _ref.data,
      getIdProperty = _ref.getIdProperty;

  if (!Array.isArray(data) || !getIdProperty || id == null) {
    return null;
  }
  var filteredList = data.reduce(function (acc, item, index) {
    if (getIdProperty(item) === id) {
      acc = index;
    }

    return acc;
  }, null);

  return filteredList !== null ? filteredList : null;
}

exports.default = findItemIndex;